import { Instagram, Shield, CheckCircle } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-white text-primary border-t border-primary/10">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <Logo className="h-24" />
            </div>
            <p className="text-primary/70 text-sm font-medium">Criando experiências de viagem extraordinárias desde 2024.</p>
            <div className="mt-4 space-y-2 text-xs text-primary/60">
              <p className="flex items-center gap-2"><CheckCircle size={14} />Registrado no CADASTUR</p>
              <p className="flex items-center gap-2"><Shield size={14} />Ministério do Turismo</p>
              <p className="font-semibold text-primary/70">CNPJ: 64.418.580/0001-14</p>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Links Rápidos</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#home" className="text-primary/70 hover:text-primary transition-colors font-semibold">Início</a></li>
              <li><a href="/#destinations" className="text-primary/70 hover:text-primary transition-colors font-semibold">Destinos</a></li>
              <li><a href="/#corporate" className="text-primary/70 hover:text-primary transition-colors font-semibold">Sobre</a></li>
              <li><a href="/#contact" className="text-primary/70 hover:text-primary transition-colors font-semibold">Contato</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Serviços</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-primary/70 hover:text-primary transition-colors font-semibold">Pacotes Personalizados</a></li>
              <li><a href="#" className="text-primary/70 hover:text-primary transition-colors font-semibold">Viagens em Grupo</a></li>
              <li><a href="#" className="text-primary/70 hover:text-primary transition-colors font-semibold">Consultoria de Viagem</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Siga-nos</h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/jmtraveloficialbr/" target="_blank" rel="noopener noreferrer" aria-label="Instagram JM Travel" className="p-2 bg-primary/10 rounded-lg hover:bg-primary transition-all duration-300 group">
                <Instagram size={20} className="text-primary group-hover:text-white" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary/20 my-8"></div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-primary/70">
          <p className="font-semibold">&copy; {currentYear} JM Travel. Todos os direitos reservados.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-primary transition-colors font-semibold">Política de Privacidade</a>
            <a href="#" className="hover:text-primary transition-colors font-semibold">Termos de Serviço</a>
            <a href="#" className="hover:text-primary transition-colors font-semibold">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
